import { useLocation, Outlet } from 'react-router-dom'
import { useTelegramWebApp } from '../../hooks/useTelegramWebApp'
import { ROUTES } from '@shared/config/routes'
import Header from './Header'
import BottomMenu from '../BottomMenu/BottomMenu'
import './Layout.css'

const Layout = () => {
  const location = useLocation()
  const { webApp } = useTelegramWebApp()

  // На главной шапка (логотип, счётчик, аватар) отрисована внутри баннера,
  // поэтому отдельный Header там не нужен.
  const showHeader =
    location.pathname !== '/profile' && location.pathname !== '/'

  // На калькуляторе нижнее меню перекрывает поля и итог — это рабочий экран
  // с формой, из него возвращаются кнопкой «назад».
  const showBottomMenu = location.pathname !== ROUTES.COST_CALCULATOR

  return (
    <div className="layout">
      {showHeader && <Header />}
      <main className="main-content">
        <Outlet />
      </main>
      {showBottomMenu && <BottomMenu />}
    </div>
  )
}

export default Layout
